/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddressResponse,
  CreateAddressDto,
  UpdateAddressDto,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Addresses<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags addresses
   * @name Create
   * @request POST:/addresses
   * @secure
   */
  create = (data: CreateAddressDto, params: RequestParams = {}) =>
    this.request<AddressResponse, any>({
      path: `/addresses`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags addresses
   * @name FindAll
   * @request GET:/addresses
   * @secure
   */
  findAll = (
    query?: {
      customer?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AddressResponse[], any>({
      path: `/addresses`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags addresses
   * @name Update
   * @request PATCH:/addresses/{id}
   * @secure
   */
  update = (id: string, data: UpdateAddressDto, params: RequestParams = {}) =>
    this.request<AddressResponse, any>({
      path: `/addresses/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags addresses
   * @name Remove
   * @request DELETE:/addresses/{id}
   * @secure
   */
  remove = (id: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/addresses/${id}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });
}
